module.exports = __webpack_public_path__ + "static/media/Wyatt.63a0ece0.jpg";